<template>
    <div>
        <Loader ref="Loader"></Loader>
        <SuccessModal ref="successModal"></SuccessModal>
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <YesNoModal ref="YesNoModal" />
        <v-flex xs12>
            <v-card>
                <v-toolbar color="secondary" dark dense>
                    <v-toolbar-title>Ops Manager Assessment Templates</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn fab small color="success">
                        <v-icon @click="InspectionTemplateDialog = true"
                            v-if="HasAccess('INSPECTION_MANAGEMENT', 'CREATE')">add</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-list>
                    <v-list-group v-for="item in InspectionTemplateData" :key="item.OpsManagerAssessmentCategory.ID"
                        :prepend-icon="item.action" no-action expand>
                        <template slot="activator">
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{ item.OpsManagerAssessmentCategory.Name }}
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-btn small fab color="primary" @click="deleteInspection(item)"
                                    v-if="HasAccess('INSPECTION_MANAGEMENT', 'DELETE')">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-list-tile>
                        </template>
                        <v-list-tile v-for="subItem in item.OpsManagerAssessments" :key="subItem.ID" @click="1==1"
                            style="width: 100%">
                            <v-list-tile-content>z
                                <v-text-field v-model="subItem.Name" style="width: 80%"></v-text-field>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-layout row wrap>
                                    <v-flex ma-1>
                                        <v-btn fab small color="success" @click="saveItem(subItem)"
                                            v-if="HasAccess('INSPECTION_MANAGEMENT', 'MODIFY')">
                                            <v-icon>save</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex ma-1>
                                        <v-btn fab small ma-1 color="primary" @click="deleteItem(subItem)"
                                            v-if="HasAccess('INSPECTION_MANAGEMENT', 'DELETE')">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-layout justify-end>
                            <v-flex class="text-xs-right" shrink>
                                <v-btn small color="success" @click="ShowItemCreateDialog(item)"
                                    v-if="HasAccess('INSPECTION_MANAGEMENT', 'CREATE')">Add item</v-btn>
                                <v-btn small color="primary" @click="ShowItemPoolDialog(item)"
                                    v-if="HasAccess('INSPECTION_MANAGEMENT', 'CREATE')">Select
                                    from pool</v-btn>
                                <v-btn small outline color="blue" v-if="HasAccess('INSPECTION_MANAGEMENT', 'CREATE')"
                                    @click="OpenAddToCustomerGroupDialog(item)">Add To Customer Group</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-list-group>
                </v-list>
            </v-card>
        </v-flex>
        <!-- DIALOG FOR INSPETION TEMPLATE CREATE -->
        <v-dialog v-model="InspectionTemplateDialog" width="600px" offset-x persistent>
            <v-form ref="jobGroupCreationDialog" @submit.prevent>
                <v-card>
                    <v-toolbar color="secondary" dark>
                        <v-toolbar-title>Create New Assessment Category</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="InspectionTemplateDialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-layout row wrap ma-4>
                        <v-flex xs12 sm12 md12 lg12 xl12>
                            <v-text-field v-model="CategoryTemplateForm.Name" :rules="fieldRules"
                                label="Assessment Category Name">
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-card-actions>
                        <v-layout justify-end>
                            <v-btn type="submit" color="primary" @click="AddInspectionTemplate()"
                                :disabled="CategoryTemplateForm.Name == null">
                                Create
                            </v-btn>
                            <v-btn flat @click="InspectionTemplateDialog = false">
                                Cancel
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- INSPECTION TEMPLATE ITEM CREATION -->
        <v-dialog v-model="InspectionItemsDialog" width="700px" offset-x persistent>
            <v-form @submit.prevent>
                <v-card>
                    <v-toolbar color="secondary" dark>
                        <v-toolbar-title>Create New Assessment</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="InspectionItemsDialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-layout row ma-4>
                        <v-flex xs12>
                            <v-text-field v-model="InspectionItemForm.Name" label="Name">
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-card-actions>
                        <v-layout justify-end>
                            <v-btn type="submit" color="primary"
                                :disabled="InspectionItemForm.Name == null || InspectionItemForm.Name.length == 0"
                                @click="AddInspectionItem()">
                                Create
                            </v-btn>
                            <v-btn flat @click="InspectionItemsDialog = false">
                                Cancel
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- ITEM POOL -->
        <v-dialog v-model="ItemPoolDialog" width="600px" offset-x persistent>
            <v-form @submit.prevent="AddItemPool">
                <v-card>
                    <v-toolbar color="secondary" dark>
                        <v-toolbar-title>Select From Item Pool</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="ItemPoolDialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <v-layout row wrap ma-4 v-for="(item, index) in PoolItems" :key="index">
                            <v-flex xs4 sm4 md4 lg4 xl4>
                                <v-checkbox :label="item.Name" v-model="item.selectedItemsFromPool"
                                    @change="checkSelectedItems(item)"></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-card-actions>
                        <v-layout justify-end>
                            <v-btn type="submit" color="primary">
                                Add
                            </v-btn>
                            <v-btn flat @click="ItemPoolDialog = false">
                                Cancel
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog v-model="AddToCustGroupDialog" width="700px" persistent>
            <v-form ref='CustomerGroupForm' @submit.prevent="AddInspectionToGroup">
                <v-card>
                    <v-toolbar color="secondary" dark dense>
                        <v-toolbar-title>Add Assessment To Customer Group</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="AddToCustGroupDialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <v-layout row wrap ma-2>
                            <v-combobox multiple label="Search for customer" v-model="SelectedCustomers"
                                :items="CustomerList" item-text="Name" item-value="ID" chips></v-combobox>
                        </v-layout>
                    </v-flex>
                    <v-card-actions>
                        <v-layout justify-end>
                            <v-btn type="submit" color="primary" :disabled="SelectedCustomers.length == 0">
                                Add
                            </v-btn>
                            <v-btn flat @click="AddToCustGroupDialog = false">
                                Cancel
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                SelectedCustomers: [],
                InspectionToAdd: null,
                CustomerList: [],
                AddToCustGroupDialog: false,
                LastOpenList: null,
                InspectionTemplateDialog: false,
                InspectionItemsDialog: false,
                ItemPoolDialog: false,
                CategoryTemplateForm: {
                    Name: null
                },
                InspectionItemForm: {
                    OpsManagerAssessmentCategoryID: 0,
                    Name: null,
                },
                InspectionItemPoolForm: [],
                TemplateID: 0,
                selectedItemsFromPool: [],
                InspectionTemplateData: [],
                fieldRules: [v => !!v || "Field is required"],
                PoolItems: [],
                SelectedPoolItems: []
            }
        },
        mounted() {
            let self = this;

            self.FetchData();
            // self.FetchInspectionTemplateData();
            self.FetchInspectionItemPool();
            self.GetCustomers();
        },
        methods: {
            GetCustomers() {
                let self = this;

                self.get(`Customer`)
                    .then(response => {
                        self.CustomerList = response.data;
                    })
                    .catch(error => {
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText(error.toString());
                    });
            },
            FetchData() {
                let self = this;

                self.get(`OpsManagerAssessments/AllGlobalCategoriesWithItems`).then(r => {
                    console.log('inspection data', r.data)
                    self.InspectionTemplateData = r.data;
                })
            },
            FetchInspectionTemplateData() {
                let self = this;

                self.get('InspectionTemplate/Complex').then(r => {
                    console.log("INSPECTION TEMPLATE WITH ITEMS", r.data)

                    self.InspectionTemplateData = r.data;
                })
            },
            FetchInspectionItemPool() {
                let self = this;

                self.get(`OpsManagerAssessments/GetAssessmentPool`).then(r => {
                    console.log("[ITEM POOL]", r.data)
                    self.PoolItems = r.data;
                })
            },
            checkSelectedItems(item) {
                let self = this;
                
                console.log('push item', item)
                if (self.SelectedPoolItems.length != 0) {
                    var exists = self.SelectedPoolItems.filter(selectedItem => {
                        return selectedItem == item.ID;
                    })
                    if (exists.length > 0) { // if it exists - splice it

                        let idx_real = -1;

                        self.SelectedPoolItems.forEach((el, idx) => {
                            if (el == item.ID)
                                idx_real = idx;
                        })

                        var index = self.SelectedPoolItems.indexOf(item.ID);
                        self.SelectedPoolItems.splice(idx_real, 1);
                    } else { // else push it
                        self.SelectedPoolItems.push(item.ID);
                    }
                } else { // array is empty, so push
                    self.SelectedPoolItems.push(item.ID);
                }

                console.log("[SELECTED POOL ITEMS]", self.SelectedPoolItems)
            },
            AddInspectionToGroup() {
                let self = this;

                console.log("[SELECTED CUSTOMERS]", self.SelectedCustomers)
                console.log("[INSPECTION TO ADD]", self.InspectionToAdd)
                let Request = {
                    CustomerList: self.SelectedCustomers,
                    Assessment: self.InspectionToAdd
                }

                self.post(`OpsManagerAssessments/PosttemplateToCustomerGroup`, Request).then(r => {
                    console.log(r.data)
                    if (r.data == true) {
                        self.AddToCustGroupDialog = false;
                        self.$refs.CustomerGroupForm.reset();
                        self.$refs.successModal.setText('Successfully posted template to customer(s)!');
                        self.$refs.successModal.show();
                    }
                })
            },
            OpenAddToCustomerGroupDialog(item) {
                let self = this;

                self.$refs.CustomerGroupForm.reset();
                console.log("[ITEM]", item)
                self.InspectionToAdd = item;
                self.AddToCustGroupDialog = true;
            },
            AddInspectionTemplate() {
                let self = this;
                let Request = self.CategoryTemplateForm;

                self.post('OpsManagerAssessments/PostAssessmentCategory', Request).then(r => {
                    console.log("Inspection Template created", r.data)
                    self.FetchData();

                    self.CategoryTemplateForm.Name = null;
                    self.InspectionTemplateDialog = false;
                })
            },
            ShowItemCreateDialog(item) {
                let self = this;
                console.log(item)

                self.InspectionItemForm.OpsManagerAssessmentCategoryID = item.OpsManagerAssessmentCategory.ID;
                self.InspectionItemsDialog = true;
            },
            ShowItemPoolDialog(item) {
                let self = this;
                console.log("[INSPECTION TEMPLATE]", item)
                self.TemplateID = item.OpsManagerAssessmentCategory.ID;
                self.ItemPoolDialog = true;
            },
            AddInspectionItem() {
                let self = this;
                let Request = self.InspectionItemForm;

                self.post('OpsManagerAssessments/PostAssessment', Request).then(r => {
                    self.FetchData();
                    self.InspectionItemsDialog = false;
                    self.InspectionItemForm = {
                        Name: null,
                    };
                    self.FetchInspectionItemPool();
                })
            },
            AddItemPool() {
                let self = this;

                let Request = self.SelectedPoolItems;

                self.post(`OpsManagerAssessments/PostPoolAssessments?categoryID=${self.TemplateID}`, Request).then(
                    r => {
                        self.FetchData();

                        self.ItemPoolDialog = false;
                    })
                //post selectedpool items

            },
            deleteItem(item) {
                let self = this;
                self.$refs.YesNoModal.show(
                    "Are you sure you want to delete this assessment?",
                    function (yes) {
                        if (yes == true) {
                            self.delete(`OpsManagerAssessments/DeleteGlobalAssessment?id=${item.ID}`, item).then(
                                    result => {
                                        self.FetchData();
                                        self.$refs.successModal.setText('Successfully deleted.');
                                        self.$refs.successModal.show(true);
                                        setTimeout(() => {
                                            self.$refs.successModal.hide();
                                        }, 1500);
                                    })
                                .catch(error => {
                                    console.warn("[SAVE] Failed to save the item", error.toString());
                                })
                        }
                    })
            },
            deleteInspection(item) {
                let self = this;

                console.log("delete inspection", item)

                self.$refs.YesNoModal.show(
                    "Are you sure you want to delete this assessment category? Customer assessments with this assessment will not be deleted.",
                    function (yes) {
                        if (yes == true) {
                            self.delete(
                                    `OpsManagerAssessments/DeleteGlobalCategory?id=${item.OpsManagerAssessmentCategory.ID}`
                                )
                                .then(result => {
                                    self.FetchData();
                                    self.$refs.successModal.setText('Successfully deleted.');
                                    self.$refs.successModal.show(true);
                                    setTimeout(() => {
                                        self.$refs.successModal.hide();
                                    }, 1500);
                                })
                                .catch(error => {
                                    console.warn("[SAVE] Failed to delete the item", error.toString());
                                })
                        }
                    })
            },
            saveItem(item) {
                let self = this;

                self.put(`OpsManagerAssessments/UpdateGlobalAssessment?id=${item.ID}`, item).then(result => {
                        self.$refs.successModal.setText('Successfully saved.');
                        self.$refs.successModal.show(true);
                        setTimeout(() => {
                            self.$refs.successModal.hide();
                        }, 1500);
                    })
                    .catch(error => {
                        console.warn("[SAVE] Failed to save the item", error.toString());
                    })
            }
        }
    }
</script>

<style>

</style>